import React, { Fragment } from 'react'
import styled from 'styled-components'
import { buildLogoutURL } from '../components/utils/Logout'
import { LogoutIcon } from '../components/icons/Logout/LogoutIcon'
import {
  AccountSettingsIcon
} from '../components/icons/AccountSettings/AccountSettingsIcon'
import { StyledClickableIcon } from '../components/icons/StyledClickableIcon'
import { EmailConsumer } from '../context/Email'
import { isResponseFull } from '../components/widgets/Email/EmailUtils'
import { buildLoginPageURL } from '../components/utils/Login'
import { LoginIcon } from '../components/icons/Login/LoginIcon'

export const MobileUserMenu = ({ widget, ecoIdentity, domain }) => {
  const {
    clientId,
    login: { location: loginLocation },
    logout: { location: logoutLocation },
    settings: { location: settingsLocation }
  } = ecoIdentity
  const {
    meta: {
      accountSettings,
      logout,
      login
    }
  } = widget

  const loginURL = buildLoginPageURL({ clientId, loginLocation, returnURL: domain })
  const logoutURL = buildLogoutURL({ logoutLocation, returnURL: domain })

  return (
    <EmailConsumer>
      {({ inbox }) => {
        const isLoggedIn = isResponseFull(inbox)

        return (
          <StyledContainer>
            {isLoggedIn ? (
              <Fragment>
                <StyledLink href={logoutURL}>
                  <LogoutIcon />
                  {logout.text}
                </StyledLink>
                <StyledLink href={settingsLocation}>
                  <AccountSettingsIcon />
                  {accountSettings.textMobile}
                </StyledLink>
              </Fragment>
            ) : (
              <StyledLink href={loginURL}>
                <LoginIcon />
                {login.text}
              </StyledLink>
            )}
          </StyledContainer>
        )
      }}
    </EmailConsumer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  gap: 24px;
  
  ${StyledClickableIcon} {
    path {
      fill: ${({ theme }) => theme.mobileUserMenu.iconColor};
    }
  }
`

const StyledLink = styled.a`
  display: flex;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.mobileUserMenu.color};

  &:hover {
    color: ${({ theme }) => theme.mobileUserMenu.hoverColor};
  }
`
